exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".payment-rhythm-view__following-payment-rhythm-message{font-size:12px;line-height:16px;font-weight:inherit;max-width:400px;margin-top:8px;color:#9fb0b5}", ""]);
// Exports
exports.locals = {
	"medium": "768px",
	"large": "1024px",
	"xlarge": "1440px"
};